'use client';

import { c as _c } from "react/compiler-runtime";
import { countryList, countryListWithFlags } from '@repo/features/country/data';
import { Button, buttonVariants, Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, Field, FieldContent, FieldDescription, FieldError, FieldLabel, Popover, PopoverContent, PopoverTrigger, Spinner } from '@repo/ui/components/start';
import { Check as CheckIcon, ChevronDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode, useMemo, useState } from 'react';
import { ReadOnlyField, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormCountrySelect = t0 => {
  const $ = _c(66);
  let className;
  let description;
  let disabled;
  let isPending;
  let label;
  let props;
  let readOnly;
  let required;
  let t1;
  let t2;
  let tooltipContent;
  if ($[0] !== t0) {
    ({
      className,
      description,
      disabled,
      display: t1,
      isPending,
      label,
      readOnly,
      required,
      tooltipContent,
      variant: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = disabled;
    $[4] = isPending;
    $[5] = label;
    $[6] = props;
    $[7] = readOnly;
    $[8] = required;
    $[9] = t1;
    $[10] = t2;
    $[11] = tooltipContent;
  } else {
    className = $[1];
    description = $[2];
    disabled = $[3];
    isPending = $[4];
    label = $[5];
    props = $[6];
    readOnly = $[7];
    required = $[8];
    t1 = $[9];
    t2 = $[10];
    tooltipContent = $[11];
  }
  const display = t1 === undefined ? "code" : t1;
  const variant = t2 === undefined ? "outline" : t2;
  const [open, setOpen] = useState(false);
  const field = useFieldContext();
  const isGhostVariant = variant === "ghost";
  const isReadOnly = useReadOnly(readOnly);
  let t3;
  if ($[12] !== field.state.value) {
    t3 = countryList.find(c => c.code === field.state.value);
    $[12] = field.state.value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const selected = t3;
  const selectedLabel = display === "name" ? selected?.name ?? selected?.code : selected?.code;
  let t4;
  if ($[14] !== field.name || $[15] !== label || $[16] !== required) {
    t4 = label && typeof label === "string" ? <FieldLabel className={cn(required && "required gap-0.5")} htmlFor={field.name}>{label}</FieldLabel> : label;
    $[14] = field.name;
    $[15] = label;
    $[16] = required;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const fieldLabel = t4;
  if (isReadOnly) {
    const t5 = selectedLabel ?? "-";
    let t6;
    if ($[18] !== fieldLabel || $[19] !== t5 || $[20] !== tooltipContent) {
      t6 = <ReadOnlyField label={fieldLabel} tooltipContent={tooltipContent}>{t5}</ReadOnlyField>;
      $[18] = fieldLabel;
      $[19] = t5;
      $[20] = tooltipContent;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    return t6;
  }
  let t5;
  if ($[22] !== className) {
    t5 = cn("group w-full justify-between font-normal", className);
    $[22] = className;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const t6 = disabled || isPending;
  const t7 = field.name;
  const t8 = !selected && "text-muted-foreground";
  let t9;
  if ($[24] !== t8) {
    t9 = cn(t8, "truncate");
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = selectedLabel ?? "-";
  let t11;
  if ($[26] !== t10 || $[27] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const t12 = isGhostVariant && "opacity-0 transition-opacity group-hover:opacity-100";
  let t13;
  if ($[29] !== t12) {
    t13 = cn("size-4 shrink-0", t12);
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = <ChevronDown className={t13} data-sentry-element="ChevronDown" data-sentry-source-file="form-country-select.tsx" />;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== isPending) {
    t15 = isPending && <Spinner className="size-4 shrink-0" />;
    $[33] = isPending;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== field.name || $[36] !== props || $[37] !== t11 || $[38] !== t14 || $[39] !== t15 || $[40] !== t5 || $[41] !== t6 || $[42] !== variant) {
    t16 = <PopoverTrigger asChild={true} data-sentry-element="PopoverTrigger" data-sentry-source-file="form-country-select.tsx"><Button className={t5} disabled={t6} id={t7} type="button" variant={variant} {...props} data-sentry-element="Button" data-sentry-source-file="form-country-select.tsx">{t11}{t14}{t15}</Button></PopoverTrigger>;
    $[35] = field.name;
    $[36] = props;
    $[37] = t11;
    $[38] = t14;
    $[39] = t15;
    $[40] = t5;
    $[41] = t6;
    $[42] = variant;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  let t18;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="bg-popover sticky top-0 z-10"><CommandInput placeholder="Search country..." data-sentry-element="CommandInput" data-sentry-source-file="form-country-select.tsx" /></div>;
    t18 = <CommandEmpty data-sentry-element="CommandEmpty" data-sentry-source-file="form-country-select.tsx">No country found.</CommandEmpty>;
    $[44] = t17;
    $[45] = t18;
  } else {
    t17 = $[44];
    t18 = $[45];
  }
  let t19;
  if ($[46] !== field || $[47] !== selected?.code) {
    t19 = countryListWithFlags.map(country => <CommandItem className="flex w-full items-center gap-2" key={country.code} onSelect={() => {
      field.handleChange(country.code);
      setOpen(false);
      field.handleBlur();
    }} value={typeof country.label === "string" ? country.label : country.name}><div className="flex w-0 grow items-center gap-2 overflow-hidden"><span className="overflow-hidden text-ellipsis whitespace-nowrap">{country.label}</span></div>{selected?.code === country.code ? <CheckIcon className="ml-auto h-4 w-4 shrink-0" /> : null}</CommandItem>);
    $[46] = field;
    $[47] = selected?.code;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t19) {
    t20 = <PopoverContent align="start" className="min-w-[--radix-popper-anchor-width] p-0" collisionPadding={10} side="bottom" data-sentry-element="PopoverContent" data-sentry-source-file="form-country-select.tsx"><Command className="max-h-50 w-full sm:max-h-67.5" data-sentry-element="Command" data-sentry-source-file="form-country-select.tsx">{t17}{t18}<CommandList data-sentry-element="CommandList" data-sentry-source-file="form-country-select.tsx"><CommandGroup data-sentry-element="CommandGroup" data-sentry-source-file="form-country-select.tsx">{t19}</CommandGroup></CommandList></Command></PopoverContent>;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== open || $[52] !== t16 || $[53] !== t20) {
    t21 = <Popover onOpenChange={setOpen} open={open} data-sentry-element="Popover" data-sentry-source-file="form-country-select.tsx">{t16}{t20}</Popover>;
    $[51] = open;
    $[52] = t16;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== description) {
    t22 = description && typeof description === "string" ? <FieldDescription>{description}</FieldDescription> : description;
    $[55] = description;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== fieldLabel || $[58] !== t21 || $[59] !== t22) {
    t23 = <FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-country-select.tsx">{fieldLabel}{t21}{t22}</FieldContent>;
    $[57] = fieldLabel;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== field.state.meta.errors) {
    t24 = <FieldError className="text-sm" errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-country-select.tsx" />;
    $[61] = field.state.meta.errors;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== t23 || $[64] !== t24) {
    t25 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormCountrySelect" data-sentry-source-file="form-country-select.tsx">{t23}{t24}</Field>;
    $[63] = t23;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  return t25;
};